import type { WidgetMessages } from './types.ts';

export const it: WidgetMessages = {
  panelTitle: 'Invia feedback',
  panelClose: 'Chiudi',
  fieldTitleLabel: 'Breve riepilogo',
  fieldTitlePlaceholder: 'Breve descrizione',
  fieldSummaryLabel: 'Dettagli',
  fieldSummaryPlaceholder: 'Passaggi per riprodurre, cosa ti aspettavi, cosa è successo davvero…',
  fieldNameLabel: 'Il tuo nome',
  fieldEmailLabel: 'La tua email',
  fieldSaveContactLabel: 'Salva il tuo nome e la tua email',
  fieldSaveContactUnavailable:
    "Il tuo browser sta bloccando l'archiviazione, quindi non è possibile salvare.",
  fieldNotifyOnFixLabel: 'Avvisami via email quando sarà risolto',
  buttonSend: 'Invia segnalazione',
  buttonSending: 'Invio in corso…',
  buttonWaitingForUploads: 'Attesa degli allegati…',
  errorTitleRequired: 'Aggiungi un breve riepilogo.',
  successHeading: 'Grazie — la tua segnalazione è stata ricevuta.',
  successCopy: (ref) => `Codice di riferimento: ${ref}`,
  successPartialNotice: (failed, total) =>
    failed === total
      ? failed === 1
        ? 'Non è stato possibile elaborare il tuo allegato, quindi non è stato incluso nella segnalazione.'
        : `Non è stato possibile elaborare i ${total} allegati, quindi non sono stati inclusi nella segnalazione.`
      : `Non è stato possibile elaborare ${failed} di ${total} allegati, quindi non sono stati inclusi nella segnalazione.`,
  successAnotherButton: 'Invia un’altra segnalazione',
  poweredBy: 'Realizzato con OnCatch',

  recordingConsentTitle: 'Registra il tuo schermo',
  recordingConsentLead: (ws) =>
    `Stai per condividere il tuo schermo con il team di supporto di ${ws} per mostrare un errore.`,
  recordingConsentBulletAdminsOnly:
    'La registrazione viene inviata solo agli amministratori del tuo workspace.',
  recordingConsentBulletMicAudio:
    'L’audio del microfono viene catturato se il browser lo supporta; vedrai una richiesta di accesso.',
  recordingConsentBulletMaxLength:
    'La durata massima è di 5 minuti — la registrazione si interrompe automaticamente al limite.',
  recordingConsentBulletRetention: (d) =>
    `Conservata per ${d} giorni, poi eliminata automaticamente.`,
  recordingConsentBulletDeletion:
    'Puoi richiedere l’eliminazione anticipata dalle impostazioni del tuo account.',
  recordingConsentCancelBtn: 'Annulla',
  recordingConsentAcceptBtn: 'Accetto, avvia la registrazione',
  recordingChoiceTitle: 'Scegli una registrazione',
  recordingChoiceLead:
    'Scegli cosa vuoi acquisire. Rivedrai ciò che viene condiviso prima dell’avvio della registrazione.',
  recordingChoiceScreen: 'Registrazione schermo',
  recordingChoiceScreenDetail: 'Registra lo schermo e, facoltativamente, l’audio del microfono.',
  recordingChoiceCamera: 'Registrazione schermo con fotocamera',
  recordingChoiceCameraDetail: 'Registra lo schermo con una sovrapposizione della fotocamera.',
  recordingChoiceAudio: 'Registrazione audio',
  recordingChoiceAudioDetail: 'Registra solo l’audio del microfono.',
  recordingChoiceUnavailable: 'Non disponibile in questo browser',
  recordingAudioConsentTitle: 'Registra audio',
  recordingAudioConsentLead: (ws) =>
    `L’audio del tuo microfono sarà condiviso con il team di assistenza di ${ws} per aiutare a spiegare questo problema.`,
  recordingAudioConsentTip:
    'Il browser chiederà ora l’accesso al microfono. Scegli il microfono da usare e consenti l’accesso.',

  recordingTimerIdle: 'Registrazione 0:00',
  recordingTimer: (m, s) => `Registrazione ${m}:${String(s).padStart(2, '0')}`,
  recordingStopBtn: 'Ferma',
  recordingStartedAnnouncement: 'Registrazione avviata',
  recordingProgressAnnouncement: (sec) => `Registrazione ${sec} secondi`,

  captureRegionHelp: 'Fai clic e trascina per selezionare un’area · Premi Esc per annullare',
  captureLabelCapturing: 'Acquisizione in corso…',
  captureLabelPreparing: 'Preparazione…',
  captureRegionCapturing: 'Acquisizione area…',

  safariUnsupportedTitle: 'La registrazione dello schermo non è supportata su questo browser',
  safariUnsupportedBody:
    'La registrazione richiede Chrome, Edge o Firefox per desktop. Puoi comunque allegare screenshot e inviare la segnalazione.',

  attachmentsLabel: 'Allegati',
  captureWholePageBtn: 'Pagina intera',
  captureSelectRegionBtn: 'Seleziona area',
  captureSelectElementBtn: 'Seleziona elemento',
  captureRecordBtn: 'Registra',
  cameraDeniedFallback: 'Accesso alla fotocamera negato — registrazione del solo schermo.',
  recordingConsentBulletCamera:
    'La fotocamera apparirà nell’angolo della registrazione. Rifiuta la richiesta della fotocamera per registrare solo lo schermo.',
  recordingConsentIncludeCameraLabel: 'Includi fotocamera',
  recordingUnsupportedInline:
    'La registrazione dello schermo non è supportata in questo browser. Gli screenshot funzionano ancora.',

  // ── Upload dropzone (#605) ───────────────────────────────────────────
  uploadDropzoneBtn: 'Carica file',
  uploadDropzoneHint: () => 'PNG, JPEG, WebP · PDF, Word (.docx)',
  uploadDropzoneCapReached: 'Limite allegati raggiunto — rimuovine uno per caricare.',
  uploadErrorUnsupportedType: 'Si possono caricare solo file PNG, JPEG, WebP, PDF o DOCX.',
  uploadErrorFileTooLarge: 'File troppo grande (max 50 MB).',
  uploadErrorGeneric: 'Caricamento non riuscito. Riprova.',
  uploadErrorTooMany: (skipped) =>
    skipped === 1
      ? '1 file saltato — limite allegati raggiunto.'
      : `${skipped} file saltati — limite allegati raggiunto.`,

  storageFullNotice: 'Allegati non disponibili',
  storageFullDetailedNotice:
    'Allegati non disponibili — spazio di archiviazione del workspace esaurito',

  challengeIntro: 'Verifica rapida per confermare che sei una persona.',
  challengeFailed: 'Verifica non riuscita. Riprova.',

  annotateTitle: 'Annota lo screenshot',
  toolArrow: 'Freccia',
  toolBox: 'Riquadro',
  toolPen: 'Disegna',
  toolText: 'Testo',
  colorRed: 'Rosso',
  colorYellow: 'Giallo',
  colorGreen: 'Verde',
  colorBlack: 'Nero',
  buttonUndo: 'Annulla',
  buttonClear: 'Cancella',
  buttonSkip: 'Salta',
  buttonSave: 'Salva',
  textInputPlaceholder: 'Scrivi etichetta, premi Invio',
  saveError: 'Impossibile salvare. Verrà inviato lo screenshot originale.',
  activeIndicator: 'attivo',
};
